<template>

  <div class="grid">

    <div class="col-12">
      <div class="card">
        <Toast />
        <Toolbar class="mb-4">
          <template v-slot:start>
            <div class="my-1">
      		    <div class="col-12 section_title"> Presupuestos </div>
            </div>
          </template>

          <template v-slot:end>

              <span class="block mt-2 md:mt-0 p-input-icon-left mr-3">
                <i class="pi pi-search" />
                <InputText
                  v-model="filters['global'].value"
                  placeholder="Buscar..."
                />
              </span>

              <Button
                label="NUEVO PRESUPUESTO"
                icon="pi pi-plus"
                class="p-button-info mr-2"
                @click="this.$router.push('/presupuestos/crear')"
              />
          </template>
        </Toolbar>

        <DataTable
          ref="dt"
          :value="budgets"
          dataKey="id"
          :paginator="true"
          :rows="10"
          :filters="filters"
          :rowClass="rowClass"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25]"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} presupuestos"
          responsiveLayout="scroll"
        >
 

        <Column
            field="document_number"
            header="Número"
            :sortable="true"
            headerStyle="min-width:5rem;"
        >
            <template #body="slotProps">
                <span class="p-column-title">Número</span>
                {{ slotProps.data.document_number }}
            </template>
        </Column>

        <Column
            field="cliente"
            header="Cliente"
            :sortable="true"
            headerStyle="min-width:10rem;"
          >
            <template #body="slotProps">
              <span class="p-column-title">Cliente</span>
              {{ giveMeName(slotProps.data.cliente) }}
            </template>
        </Column>

        <Column
            field="Fecha"
            header="Fecha"
            :sortable="true"
            headerStyle="min-width:3rem;"
          >
            <template #body="slotProps">
              <span class="p-column-title">Fecha</span>
              {{ slotProps.data.date_at }}
            </template>
        </Column>

        <Column
            field="terms_of_sale"
            header="Condic. Venta"
            :sortable="true"
            headerStyle="min-width:3rem;"
          >
            <template #body="slotProps">
              <span class="p-column-title">Condic. Venta</span>
              {{ getTerms(slotProps.data.terms_of_sale) }}
            </template>
        </Column>

        <Column
            field="delivery_term"
            header="Plazo Entrega"
            :sortable="true"
            headerStyle="min-width:3rem;"
          >
            <template #body="slotProps">
              <span class="p-column-title">Plazo Entrega</span>
              {{ slotProps.data.delivery_term }}
            </template>
        </Column>

        <Column
            field="status"
            header="Estatus"
            :sortable="false"
            headerStyle="min-width:3rem;"
          >
            <template #body="slotProps">
              <span :class="getStatusClass(slotProps.data.status)">
                {{ giveMeStatus(slotProps.data.status) }}
              </span> 
            </template>
        </Column>

        
          
          <Column headerStyle="min-width:4rem;">
            <template #body="slotProps">
              <Button
                v-if="! slotProps.data.status"
                icon="pi pi-check"
                class="p-button-rounded p-button-primary mr-2"
                @click="confirmApproveBudget(slotProps.data)"
              />
              <Button
                icon="pi pi-eye"
                class="p-button-rounded p-button-danger mr-2"
                @click="this.$router.push('/presupuesto-ver/' + slotProps.data.id)"
              />
              
              <Button
                icon="pi pi-file"
                class="p-button-rounded p-button-danger mr-2"
                @click="print(slotProps.data)"
              />

              <Button
                icon="pi pi-pencil"
                class="p-button-rounded p-button-success mr-2"
                @click="editBudget(slotProps.data)"
              />
              <Button
                icon="pi pi-trash"
                class="p-button-rounded p-button-warning mt-2"
                @click="confirmDeleteBudget(slotProps.data)"
              /> 
            </template>
          </Column>
        </DataTable>

        <Dialog
          v-model:visible="deleteBudgetDialog"
          :style="{ width: '450px' }"
          header="Confirmación"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <i
              class="pi pi-exclamation-triangle mr-3"
              style="font-size: 2rem"
            />
            <span v-if="budget"
              >Eliminaras el Presupuesto <b>{{ budget.document_number }}</b
              >?</span
            >
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteBudgetDialog = false"
            />
            <Button
              label="Sí"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteBudget"
            />
          </template>
        </Dialog>

        <Dialog
          v-model:visible="approveBudgetDialog"
          :style="{ width: '450px' }"
          header="Confirmación"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
            <span v-if="budget"
              >Aprobarás el Presupuesto <b>{{ budget.document_number }}</b
              >?</span
            >
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="approveBudgetDialog = false"
            />
            <Button
              label="Sí"
              icon="pi pi-check"
              class="p-button-text"
              @click="approveBudget(budget)"
            />
          </template>
        </Dialog>

        <Dialog
          v-model:visible="deleteBudgetsDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <i
              class="pi pi-exclamation-triangle mr-3"
              style="font-size: 2rem"
            />
            <span v-if="budget">Seguro?</span>
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteBudgetsDialog = false"
            />
            <Button
              label="Sí"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteSelectedBudgets"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import CrudService from "../services/crud.service";

export default {
  data() {
    return {
      countDemorado: 20,
      countPronta:  40,
      countCumplid: 10,
      routeName: null,
      budgets: null,
      budgetDialog: false,
      deleteBudgetDialog: false,
      approveBudgetDialog: false,
      deleteBudgetsDialog: false,
      budget: {},
      selectedBudgets: null,
      filters: {},
      submitted: false,
      validationErrors: null,
      materiales: [],
      tipos: [
        { value: 0, label: "Con plisas" },
        { value: 1, label: "Sin plisas" },
        { value: 2, label: "Filtros Cartucho" },
        { value: 3, label: "Lavable" },
      ],
      calidades: [
        { value: 0, label: "G2" },
        { value: 1, label: "G4" },
        { value: 2, label: "M5-M6" },
        { value: 3, label: "F7" },
        { value: 4, label: "F8-F9" },
      ],
    };
  },
   
  created() {
    this.routeName = this.$route.name;
     
    this.initFilters();
  },
  mounted() {
    CrudService.getCRUD('presupuestos').then((data) => (this.budgets = data));
    CrudService.getCRUD('material').then((data) => (this.materiales = data));
    console.log('this.budgets')
    console.log(this.budgets)
  },
  methods: {
    getType(index) {
      return this.tipos[index]?.label;
    },
    getQuality(index) {
      return this.calidades[index]?.label;
    },
    giveMeStatus(status) {
      return status;
    },
    getStatusClass(status) {
      if (status=='APROBADO') {
        return 'status_box status-success';
      }
      return '';
    },
    getTerms(term) {
      return (term == 1 ? 'Crédito' : 'Contado');
    },
    giveMeClass(data){

      let today = new Date();
      let dateout = new Date(data.dateout);

      // diff in days between today and dateout
      let diff = Math.floor(
        (Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()) -
          Date.UTC(
            dateout.getFullYear(),
            dateout.getMonth(),
            dateout.getDate()
          )) /
          (1000 * 60 * 60 * 24)
      );
      //check if diff is less than 7 days
      if (diff >= 7 && data.status !== 3) {
        //console.log(data)
        this.countDemorado++;
        return "rowbad";
      }
      
      //check if diff is less than 14 days
      if (diff > -7 && diff < 0 && data.status !== 3) {
        this.countPronta++;
        return "rowwarn";
      }

      //check if diff is less than 14 days
      if (diff < 0 && data.status == 3) {
        this.countCumplid++;
        return "rowgood";
      }

      return null;
    },
    rowClass(data) {

      switch(data.status){
        case 2:
          return "rowbad";
        case 3:
          return "rowwarn";
        case 4:
          return "rowgood";
        default:
          return null;
      }
      //console.log(data.id)
      //return this.giveMeClass(data)

    },
    giveMeName(client) {
      if (client && client.name) {
        return client.name;
      }
    },
    formatCurrency(value) {
      if (value)
        return value.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        });
      return;
    },
    formatDate(value){
      // format date to dd-mm-yyyy
      if (value) {
        let date = new Date(value);
        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();
        return day.toString().padStart(2, '0') + '/' + month.toString().padStart(2, '0') + '/' + year;
      }
      
    },
    currencyName(value){

      switch (value) {
        case 1:
          return 'Dolar';
          break;
        case 0:
          return 'Peso';
          break;
        case 2:
          return 'Euro';
          break;
        default:
          return 'Otro';
          break;
        }
    },

    statusName(value){

      switch (value) {

        case 0:
          return 'Sin iniciar';
          break;
        case 1:
          return 'En proceso';
          break;
        case 2:
          return 'En calidad';
          break;
        case 3:
          return 'Finalizada';
          break;
        default:
          return 'Otro';
          break;
        }
    },
    openNew() {
      this.budget = {};
      this.submitted = false;
      this.budgetDialog = true;
    },
    hideDialog() {
      this.budgetDialog = false;
      this.submitted = false;
    },
        displayErrors(errors) {
      
              for (let key in errors) {

                this.validationErrors.push({ "field": key, "message": errors[key] });

                let error = errors[key];
                this.$toast.add({
                  severity: "error",
                  summary: "Error!",
                  detail: error[0],
                  life: 3000,
                });
              }
    },
    saveBudget() {
      this.submitted = true;
      if (this.budget.name.trim()) {
        if (this.budget.id) {
          CrudService.updateCRUD(this.routeName, this.routeName, this.budget).then(
            (data) => {

            this.validationErrors = [];
            if (data.status == 400) { 

              this.displayErrors(data.data);

            } else {
              this.$toast.add({
                severity: "success",
                summary: "Éxito!",
                detail: "Actualizado correctamente.",
                life: 3000,
              });
              this.budgets[this.findIndexById(this.budget.id)] = this.budget;
              this.budgetDialog = false;
              this.budget = {};
            }
          });
        } else {
          CrudService.createCRUD(this.routeName, this.routeName, this.budget).then(
            (data) => {
              
            this.validationErrors = [];
            if (data.status == 400) { 

              this.displayErrors(data.data);
              
              } else {
                this.budgets.push(this.budget);
                this.$toast.add({
                  severity: "success",
                  summary: "Éxito!",
                  detail: "Creado correctamente.",
                  life: 3000,
                });
                this.budgetDialog = false;
                this.budget = {};
              }
            }
          );
        }
      }

    },
    downloadFile(response, filename) {
    // It is necessary to create a new blob object with mime-type explicitly set
    // otherwise only Chrome works like it should
    var newBlob = new Blob([response.body], {type: 'application/pdf'})

    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(newBlob)
      return
    }

    // For other browsers:
    // Create a link pointing to the ObjectURL containing the blob.
    const data = window.URL.createObjectURL(newBlob)
    var link = document.createElement('a')
    link.href = data
    link.download = filename + '.pdf'
    link.click()
    setTimeout(function () {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(data)
    }, 100)
  },
  print(budget) {
      this.budget = budget;      
      this.submitted = true; 

      const API_URL = process.env.VUE_APP_ROOT_API;

      window.open(API_URL + '/presupuesto-pdf/presupuesto-pdf/' + this.budget.id);
      /*
      CrudService.fileCRUD('imprimir-presupuesto/imprimir-presupuesto', this.budget).then(
        (response) => {          
          this.validationErrors = [];
          this.downloadFile(response, 'presupuesto')
        }
      );
      */
    },
    editBudget(budget) {
      this.budget = { ...budget };
      //this.budgetDialog = true;
      this.$router.push('/presupuestos/editar/'+this.budget.id)
    },
    confirmDeleteBudget(budget) {
      this.budget = budget;
      this.deleteBudgetDialog = true;
    },
    confirmApproveBudget(budget) {
      this.budget = budget;
      this.approveBudgetDialog = true;
    },
    approveBudget(budget) {
      this.budget = budget;      
      this.submitted = true;          
      CrudService.createCRUD('aprobar-presupuesto', 'aprobar-presupuesto', this.budget).then(
        (data) => {          
          this.validationErrors = [];
          if (data.status == 400) { 
            this.displayErrors(data.data);          
          } else {
            this.$toast.add({
              severity: "success",
              summary: "Éxito!",
              detail: "Aprobado correctamente.",
              life: 3000,
            });
            CrudService.getCRUD('presupuestos').then((data) => (this.budgets = data));            
            this.approveBudgetDialog = false;
            this.budget = {};
          }
        }
      );
    },
    deleteBudget() {
      
      CrudService.deleteCRUD(this.routeName, this.routeName, this.budget.id).then(
        (data) => {
          //this.budgets = this.budgets.filter((val) => val.id != this.budget.id);
          this.budgets.splice(this.findIndexById(data.data.id), 1);

          this.$toast.add({
            severity: "success",
            summary: "Éxito!",
            detail: "Eliminado correctamente.",
            life: 3000,
          });
        }
      );

      this.deleteBudgetDialog = false;
      this.budget = {};
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.budgets.length; i++) {
        if (this.budgets[i].id == id) {
          index = i;
          break;
        }
      }
      return index;
    },
    createId() {
      let id = "";
      var chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) {
        id += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return id;
    },
    exportCSV() {
      this.$refs.dt.exportCSV();
    },
    confirmDeleteSelected() {
      this.deleteBudgetsDialog = true;
    },
    deleteSelectedBudgets() {
      this.budgets = this.budgets.filter(
        (val) => !this.selectedBudgets.includes(val)
      );
      this.deleteBudgetsDialog = false;
      this.selectedBudgets = null;
      this.$toast.add({
        severity: "success",
        summary: "Éxito!",
        detail: "Eliminado correctamente.",
        life: 3000,
      });
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
};
</script>

<style scoped>
        .status_box {

          display: inline-block;
          width: 95px;
          font-weight: bolder;
          text-align: center;
          padding: 5px;
          text-transform: uppercase;
        }
        .status-success {
            border: 1px solid #44b73a71;
            background-color: #44b73a71;
        }
        .status-2 {
            border: 1px solid #ff99005b;
            background-color: #ff99005b;
        }
        .status-1 {
            border: 1px solid #1c96c256;
            background-color: #1c96c256;
          
        }
        .status-0 {
            border: 1px solid #d8d8d89a;
            background-color: #d8d8d89a;
        }
</style>
